import { call, put } from 'redux-saga/effects';
import * as R from 'remeda';
import { uploadFile } from 'store/glue/operation/uploadFile';
import { sagaWrapper } from 'store/helpers';
import { ActionType } from 'typesafe-actions';

import * as integrationsActions from './actions';

// Delegates to the uploadFile operation (which handles tenantId + feature
// guard + toast-on-failure), then re-triggers a page fetch so the table
// picks up the new row.
export function* startUploadFileSaga(
  action: ActionType<typeof integrationsActions.startUploadFile>,
) {
  function* saga() {
    const file = action.payload;
    if (!R.isDefined(file)) return;

    yield call(uploadFile, { file });

    yield put(integrationsActions.startFetchPage());
  }

  yield call(sagaWrapper, { saga, type: action.type });
}
